import type { ProStatus } from '../../utils/RevenueCatWrapper';

// Whether the navbar should show GET PRO+. Everyone known not to be entitled to
// PRO or PRO+ sees it, signed in or not — the signed-out visitor is the one the
// upsell is most for. Hidden while the user lookup is in flight so a subscriber
// never sees it flash, and when RevenueCat couldn't be asked, so a failed
// request never shows it to someone who has paid. The mobile off-canvas menu
// applies the same rule server-side in NavHelper#show_pro_upsell?.
export const proUpsellVisible = ({ loading, proStatus }: { loading: boolean; proStatus: ProStatus }): boolean =>
  !loading && proStatus === 'free';
